/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import {
  createStore,
  applyMiddleware,
  combineReducers,
} from 'redux';
import {
  routerMiddleware,
  routerReducer as routing,
} from 'react-router-redux';
import { intlReducer as intl } from 'react-intl-redux';
import thunk from 'redux-thunk';
import api from '../middleware/api';
import reducers from '../reducers';
import intlState from './intlState';
import authState from './authState';

const rootReducer = combineReducers({
  ...reducers,
  routing,
  intl,
});

export default (history, preloadedState) => {
  const router = routerMiddleware(history);
  const preload = {
    ...preloadedState,
    intl: intlState,
    auth: authState(),
  };
  return createStore(
    rootReducer,
    preload,
    applyMiddleware(router, thunk, api));
};




// WEBPACK FOOTER //
// ./src/redux/store/configureStore.js